import { useState, useMemo } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Stack,
  Chip,
} from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SuscripcionesDetalleDialog from "./SuscripcionesDetalleDialog";
import { SEMANTIC } from "./theme/brand";

export default function DashboardSuscripciones({ store, subs, onOpenConfig }) {
  const [grupoDetalle, setGrupoDetalle] = useState(null);

  // Dinero en oportunidad: leads calientes sin suscripción + suscripciones por vencer renovables
  const dineroOportunidad = useMemo(() => {
    if (!subs.hayRecurrentes) return 0;
    const renovable = (subs.dinero?.enRiesgo || 0) + (subs.dinero?.perdido || 0);
    return renovable;
  }, [subs]);

  if (!subs.hayRecurrentes || !subs.dinero) return null;

  return (
    <>
      <Card variant="outlined" sx={{ mt: 3, borderTop: 3, borderTopColor: "info.main" }}>
        <CardContent>
          <Stack direction="row" spacing={1} alignItems="center" mb={2} flexWrap="wrap" useFlexGap>
            <AutorenewIcon color="info" />
            <Typography variant="subtitle1">Suscripciones</Typography>
            <Chip label={`${subs.tasaRenovacion}% renovación`} size="small" color={subs.tasaRenovacion >= 70 ? "success" : subs.tasaRenovacion >= 40 ? "warning" : "error"} />
            {dineroOportunidad > 0 && (
              <Chip label={`${store.config.moneda} ${dineroOportunidad.toLocaleString()} recuperable`} size="small" color="warning" variant="outlined" />
            )}
          </Stack>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <Box onClick={() => subs.dinero.countActivas > 0 && setGrupoDetalle("activa")} sx={{ textAlign: "center", p: 1, bgcolor: SEMANTIC.revenueTint, borderRadius: 1, cursor: subs.dinero.countActivas > 0 ? "pointer" : "default", "&:hover": subs.dinero.countActivas > 0 ? { opacity: 0.85 } : {} }}>
                <Typography variant="h5" fontWeight={800} color="success.main">{subs.dinero.countActivas}</Typography>
                <Typography variant="caption" color="text.secondary">Activas</Typography>
                <Typography variant="body2" fontWeight={700} color="success.main">
                  {store.config.moneda} {subs.dinero.activo.toLocaleString()}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Box onClick={() => subs.dinero.countPorVencer > 0 && setGrupoDetalle("por_vencer")} sx={{ textAlign: "center", p: 1, bgcolor: SEMANTIC.warningTint, borderRadius: 1, cursor: subs.dinero.countPorVencer > 0 ? "pointer" : "default", "&:hover": subs.dinero.countPorVencer > 0 ? { opacity: 0.85 } : {} }}>
                <Typography variant="h5" fontWeight={800} color="warning.main">{subs.dinero.countPorVencer}</Typography>
                <Typography variant="caption" color="text.secondary">Por vencer</Typography>
                <Typography variant="body2" fontWeight={700} color="warning.main">
                  {store.config.moneda} {subs.dinero.enRiesgo.toLocaleString()}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Box onClick={() => subs.dinero.countVencidas > 0 && setGrupoDetalle("vencida")} sx={{ textAlign: "center", p: 1, bgcolor: SEMANTIC.dangerTint, borderRadius: 1, cursor: subs.dinero.countVencidas > 0 ? "pointer" : "default", "&:hover": subs.dinero.countVencidas > 0 ? { opacity: 0.85 } : {} }}>
                <Typography variant="h5" fontWeight={800} color="error.main">{subs.dinero.countVencidas}</Typography>
                <Typography variant="caption" color="text.secondary">Vencidas</Typography>
                <Typography variant="body2" fontWeight={700} color="error.main">
                  {store.config.moneda} {subs.dinero.perdido.toLocaleString()}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6} sm={3}>
              <Box sx={{ textAlign: "center", p: 1, bgcolor: SEMANTIC.potentialTint, borderRadius: 1 }}>
                <Typography variant="h5" fontWeight={800} color="info.main">{subs.ventasRecurrentes.length}</Typography>
                <Typography variant="caption" color="text.secondary">Suscripciones totales</Typography>
              </Box>
            </Grid>
          </Grid>
          {subs.alertasSuscripcion.length > 0 && (
            <Stack spacing={0.5} mt={2}>
              {subs.alertasSuscripcion.slice(0, 5).map((a, i) => (
                <Typography key={i} variant="caption" color={a.tipo === "error" ? "error.main" : "warning.main"}>
                  {a.mensaje}
                </Typography>
              ))}
            </Stack>
          )}
        </CardContent>
      </Card>

      <SuscripcionesDetalleDialog
        grupo={grupoDetalle}
        ventas={grupoDetalle ? (subs.grupos[grupoDetalle] || []) : []}
        store={store}
        onClose={() => setGrupoDetalle(null)}
        onOpenConfig={onOpenConfig}
      />
    </>
  );
}
